import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Notification\NotificationMarkAsReadController::__invoke
* @see app/Http/Controllers/Notification/NotificationMarkAsReadController.php
* @route '/api/notification/mark-as-read/{notification}'
*/
const NotificationMarkAsReadController = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: NotificationMarkAsReadController.url(args, options),
    method: 'post',
})

NotificationMarkAsReadController.definition = {
    methods: ["post"],
    url: '/api/notification/mark-as-read/{notification}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Notification\NotificationMarkAsReadController::__invoke
* @see app/Http/Controllers/Notification/NotificationMarkAsReadController.php
* @route '/api/notification/mark-as-read/{notification}'
*/
NotificationMarkAsReadController.url = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { notification: args }
    }

    if (Array.isArray(args)) {
        args = {
            notification: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        notification: args.notification,
    }

    return NotificationMarkAsReadController.definition.url
            .replace('{notification}', parsedArgs.notification.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Notification\NotificationMarkAsReadController::__invoke
* @see app/Http/Controllers/Notification/NotificationMarkAsReadController.php
* @route '/api/notification/mark-as-read/{notification}'
*/
NotificationMarkAsReadController.post = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: NotificationMarkAsReadController.url(args, options),
    method: 'post',
})

export default NotificationMarkAsReadController